import Router from "vue-router";
import AuthRoutes from './routes-auth';
import PageRoutes from './routes-page';
import DashboardRoutes from './routes-dashboard';
import IntroductionRoutes from './routes-introduction';
import NotFoundContainer from '../components/NotFoundContainer/NotFoundContainer.vue';
import multiguard from 'vue-router-multiguard';
import AuthGuards from "../guards/AuthGuards";

const router = new Router({
    mode: 'history',
    routes: [
        AuthRoutes,
        PageRoutes,
        DashboardRoutes,
        IntroductionRoutes,
        { path: '**/*', component: NotFoundContainer },
    ]
});

router.beforeEach(multiguard([
    AuthGuards.synchronizeUser,
    AuthGuards.isAuthenticated,
    AuthGuards.isUnauthenticated,
    AuthGuards.restrictXMLSupplier,
    AuthGuards.restrictContractManager,
    AuthGuards.restrictSupplier,
    AuthGuards.admin
]));

export default router;



// WEBPACK FOOTER //
// ./src/routes/index.js